import axios from 'axios'


const state = {
    lowi: {
        isLoading: false,
        data: [],
    },
    paths: {
        submitXLSX: '/api/utils/read-xlsx/',
        lowidataPath: '/api/atenciones/lowi-data/',
    },
}

const mutations = {
    lowi: (state, data) => {
        state.lowi.data = data
    },
    lowiData: (state, data) => {
        state.lowi.data = data
    },
    isLoadingLowiData: (state, value) => {
        state.lowi.isLoading = value
    },
}

const actions = {
    async uploadMonthlyFee({ state, dispatch }, params) {
        dispatch('util/exportDB', {
            params: {
                task_to_do: 'load_lowi_data',
            },
            files: [params.file],
            path: state.paths.submitXLSX,
        }, { root: true })
    },
    async getLowiData({ commit, state, dispatch, getters }, date) {
        // try{
            commit('isLoadingLowiData', true)
            const { data } = await axios.get(getters.getEndpointFromPath(state.paths.lowidataPath), { 
                params: {
                    date: date,
                }
            })
            commit('lowiData', data)
            commit('isLoadingLowiData', false)
        // } catch (error) {
        //     dispatch('util/showStatusSnackBar', {
        //         statusType: 'error',
        //         message: 'Ha habido un error al cargar los datos',
        //     }, { root: true })
        // }
    },
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    ),
}

const modules = {

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
    modules
}